import api from '@/apis/di/typeOfFundAPI';
import Crud from './crudBaseCache.js';
var crud = new Crud('typeOfFund', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_fund',
    field: {
      key: 'fund_id',
      code: 'fund_code',
      name: 'fund_name',
      quickFollow: 'inactive', // TPNam-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
